import * as React from 'react'

type Props = {
  'aria-label'?: string
  children: React.ReactNode
  className?: string
  inputRef?: { current: HTMLElement | null }
  style?: { menu?: string }
}

function Menu(props: Props) {
  const {
    'aria-label': ariaLabel,
    className = 'nav',
    children,
    inputRef,
    style = {},
  } = props
  return (
    <nav ref={inputRef} aria-label={ariaLabel} className={className}>
      <ul className={style.menu}>{children}</ul>
    </nav>
  )
}

export default Menu
